import { useCallback, useContext, useEffect, useState } from 'react';

import {
  ColSize,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import { FormCoverages } from './components/Form';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepThreeFormContext } from '../../../../../StepThree/contexts/StepThreeForm';

export const PropertyDataSection = () => {
  const { homeQuotationComponents } = useContext(StepThreeFormContext);

  const [activeTab, setActiveTab] = useState<any>(
    homeQuotationComponents[0]?.nroComponente
  );
  const [tabs, setTabs] = useState<Array<any>>([]);

  const createTabs = useCallback(() => {
    const newTabs = homeQuotationComponents.map(
      (homeComponent, index: number) => ({
        children: (
          <FormCoverages
            key={`${homeComponent.codPlan}-${index}`}
            homeComponent={homeComponent}
          />
        ),
        closable: false,
        forceRender: true,
        key: homeComponent.nroComponente,
        label: `Hogar ${homeComponent.nroComponente}`,
      })
    );

    setTabs(newTabs);
  }, [homeQuotationComponents, setTabs]);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <RowSize className='mt-1'>
      <ColSize size={100}>
        <Tabs
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={tabs}
        />
      </ColSize>
    </RowSize>
  );
};
